<template>
    <p class="text-button" :style="{ opacity: btn.hideButton ? 0 : 1, fontSize: btn.fontSize+'px', lineHeight: btn.lineHeight, borderRadius: btn.borderRadius+'px', textAlign: btn.textAlign, backgroundColor: btn.btnColor, color: btn.btnFontColor, border: btn.borderWidth+'px solid '+btn.borderColor }" @click="$emit('clicked',btn)">
        <img v-if="btn.image" :src="btn.image" width="100%" :style="{ borderRadius: btn.borderRadius+'px' }" />
        <span :class="btn.css"  style="width: 100%;float: left;" :style="{ position: btn.image ? 'absolute' : '', bottom: btn.image ? '-29px' : '', left: btn.image ? btn.borderRadius+'px' : '', width: btn.image ? ( btn.width - (btn.borderRadius * 2) +'px' ) : '100%' }" v-html="btn.value.replace(/\n/g,'<br>')"></span>
    </p>
</template>

<script>

export default {
    props: ['btn']
}    
</script>

<style lang="scss"> 
.text-button {
    width: 100%;
    display: flex;
    align-items: center;
    > span {
        &:empty {
            min-height: 100%;
        }
    }
}
</style>